export enum ItemType {
    Performance,    // 0
    Exchange,       // 1
    ExchangeAddOn,  // 2
    Flex,           // 3
    Fixed,          // 4
    Super           // 5
}
